import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.9531 3.82812C15.3047 4.21875 15.5 4.64844 15.5 5.15625V18.125C15.5 18.6719 15.3047 19.1016 14.9531 19.4531C14.5625 19.8438 14.1328 20 13.625 20H2.375C1.82812 20 1.39844 19.8438 1.04688 19.4531C0.65625 19.1016 0.5 18.6719 0.5 18.125V1.875C0.5 1.36719 0.65625 0.9375 1.04688 0.546875C1.39844 0.195312 1.82812 0 2.375 0H10.3438C10.8516 0 11.2812 0.195312 11.6719 0.546875L14.9531 3.82812ZM14.0547 4.72656L10.7734 1.44531C10.6953 1.36719 10.5781 1.32812 10.5 1.25V5H14.25C14.1719 4.92188 14.1328 4.80469 14.0547 4.72656ZM13.625 18.75C13.7812 18.75 13.9375 18.7109 14.0547 18.5938C14.1719 18.4766 14.25 18.3203 14.25 18.125V6.25H10.1875C9.91406 6.25 9.67969 6.17188 9.52344 5.97656C9.32812 5.82031 9.25 5.58594 9.25 5.3125V1.25H2.375C2.17969 1.25 2.02344 1.32812 1.90625 1.44531C1.78906 1.5625 1.75 1.71875 1.75 1.875V18.125C1.75 18.3203 1.78906 18.4766 1.90625 18.5938C2.02344 18.7109 2.17969 18.75 2.375 18.75H13.625Z",
		fill: "currentColor"
	})
});
export default SvgFile;
